// Local translations
export const T = {
  en_GB: {
    // Dialog
    editPortfolio: "Edit Portfolio",
    createPortfolio: "Create Portfolio",
    editDescription: "Update the portfolio name and description",
    createDescription: "Create a new portfolio for a specific risk score",
    // Form
    riskScoreHint:
      "Choose one of the risk scores defined by the assigned risk model. Several portfolios may share a score as long as their platform visibility does not overlap.",
    platforms: "Platforms",
    platformsHint:
      "Platforms this portfolio is visible under. None selected = not visible under any platform.",
    portfolioName: "Portfolio Name",
    portfolioNamePlaceholder: "e.g., Conservative Growth",
    description: "Description",
    descriptionPlaceholder: "Optional description",
    // Validation
    portfolioNameRequired: "Portfolio name is required",
    riskScoreInvalid: "Selected risk score is not available",
    riskScoreRequired: "Risk score is required",
    // Errors
    failedToUpdate: "Failed to update portfolio",
    failedToCreate: "Failed to create portfolio",
    // Actions
    cancel: "Cancel",
    save: "Save",
    create: "Create",
  },
  nb_NO: {
    // Dialog
    editPortfolio: "Rediger portefølje",
    createPortfolio: "Opprett portefølje",
    editDescription: "Oppdater porteføljens navn og beskrivelse",
    createDescription: "Opprett en ny portefølje for en spesifikk risikoskår",
    // Form
    riskScoreHint:
      "Velg en av risikoskårene som er definert av den tilknyttede risikomodellen. Flere porteføljer kan dele en skår så lenge plattformsynligheten ikke overlapper.",
    platforms: "Plattformer",
    platformsHint:
      "Plattformer denne porteføljen er synlig under. Ingen valgt = ikke synlig under noen plattform.",
    portfolioName: "Porteføljenavn",
    portfolioNamePlaceholder: "f.eks. Konservativ vekst",
    description: "Beskrivelse",
    descriptionPlaceholder: "Valgfri beskrivelse",
    // Validation
    portfolioNameRequired: "Porteføljenavn er påkrevd",
    riskScoreInvalid: "Valgt risikoskår er ikke tilgjengelig",
    riskScoreRequired: "Risikoskår er påkrevd",
    // Errors
    failedToUpdate: "Kunne ikke oppdatere portefølje",
    failedToCreate: "Kunne ikke opprette portefølje",
    // Actions
    cancel: "Avbryt",
    save: "Lagre",
    create: "Opprett",
  },
} as const;
